import { FC } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material';
import { useTableFilters } from '../context';
import { FilterComponentProps, TableFilterOptionItem } from './types';

const CheckboxFilter: FC<FilterComponentProps> = ({ options, filterId }) => {
  const { selectedFilters: allSelectedFilters, changeFilters } = useTableFilters();
  const selectedFilters = allSelectedFilters[filterId];

  const handleCheckboxChange = (checked: boolean, option: TableFilterOptionItem) => {
    if (checked) {
      changeFilters(filterId, [...selectedFilters, option]);
    } else {
      const prevFilters = [...selectedFilters];
      changeFilters(
        filterId,
        prevFilters.filter((filter) => filter.id !== option.id),
      );
    }
  };

  return (
    <Stack>
      {options?.map((option: TableFilterOptionItem) => (
        <FormGroup key={option.id}>
          <FormControlLabel
            label={<Typography fontSize="1.8rem">{option.label}</Typography>}
            labelPlacement="end"
            control={
              <Checkbox
                size="large"
                checked={selectedFilters.some((value: TableFilterOptionItem) => value.id === option.id)}
                onChange={(event) => handleCheckboxChange(event?.target.checked, option)}
              />
            }
          />
        </FormGroup>
      ))}
    </Stack>
  );
};

export default CheckboxFilter;
